import { render, staticRenderFns } from "./CourseStudentInfoPage.vue?vue&type=template&id=a5bb185c&scoped=true"
import script from "./CourseStudentInfoPage.vue?vue&type=script&lang=js"
export * from "./CourseStudentInfoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bb185c",
  null
  
)

export default component.exports